import { useEffect } from "react";

const MapStatic = ({position}) => {
    useEffect(() => {
        // Coordenadas da Rua Ponta Porã, 447
        const location = { lat: position.lat, lng: position.lng };
        const locationCompany = {lat:-23.529888,lng:-46.708498};
        // Estilos personalizados do mapa
        const mapStyle = [
          {
            "elementType": "geometry",
            "stylers": [
              { "color": "#1e1e1e" } // Cor cinza escuro para o fundo
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              { "color": "#1e1e1e" }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              { "color": "#4b4b4b" } // Texto branco
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              { "color": "#111111" } // Ruas brancas
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
              { "color": "#111111" } // Bordas das ruas brancas
            ]
          },
          {
        "featureType": "road.highway",
        "elementType": "labels.text",
        "stylers": [
          { "visibility": "off" } // Oculta os rótulos de texto nas rodovias
        ]
      },
          {
            "featureType": "poi", // Ponto de interesse (POIs) como hospitais, igrejas, etc.
            "stylers": [
              { "visibility": "off" } // Desativa os POIs
            ]
          },
          {
            "featureType": "transit", // Remover ícones de transporte público
            "stylers": [
              { "visibility": "off" } // Desativa os ícones de transporte
            ]
          }
        ];
    
        // Criação do mapa
        const map = new window.google.maps.Map(document.getElementById("map"), {
          zoom: 14,
          center: location,
          styles: mapStyle, // Aplicação do estilo personalizado
          mapTypeControl: false, // Desabilita a opção de mudar para o modo satélite
            streetViewControl: false, // Desabilita o controle do Street View
        });

        
        new window.google.maps.Marker({
          position: locationCompany,
          map: map,
        });
        
        if(location.lat != null && location.lng != null) {
          // Adiciona um marcador no centro do mapa
          new window.google.maps.Marker({
            position: location,
            map: map,
          });
        }
        
    }, [position]);
    

    return <div id="map" style={{ height: "100%", width: "90%" }} />;
};

export default MapStatic;